
import { BindDeviceActions, BindDeviceActionTypes } from '../actions/bind-device.actions';

export interface State {
}

export const initialState: State = {

};

export function reducer(state = initialState, action: BindDeviceActions): State {
  switch (action.type) {

    case BindDeviceActionTypes.LoadBindDevices:
      return state;

    default:
      return state;
  }
}
